import {
  accessAuthHeaders,
  clearAccessToken,
  readAccessToken,
  writeAccessToken,
} from '../../lib/access-token-storage.js'

/**
 * Jeton d'accès à une demande de réservation, remis soit à la création, soit
 * par le mur du nom (voir `access-token-storage.ts`).
 */
export const readReservationToken = (reservationId: string): null | string =>
  readAccessToken('reservation', reservationId)

export const writeReservationToken = (reservationId: string, token: string): void =>
  writeAccessToken('reservation', reservationId, token)

export const clearReservationToken = (reservationId: string): void =>
  clearAccessToken('reservation', reservationId)

export const reservationAuthHeaders = (reservationId: string): Record<string, string> =>
  accessAuthHeaders('reservation', reservationId)
